<template>
	<section>
		<b-modal
			ref="modalLogin"
			ok-title="Acceder"
			hide-header
			hide-footer
			centered
			no-close-on-backdrop
			no-close-on-esc
			hide-backdrop
			no-fade
			>
			<b-overlay :show="loading" no-wrap></b-overlay>
			<div class="text-center">
				<img :src="logo" style="max-width: 200px">
				<h3 class="text-center">Recover your password</h3>
			</div>
			<hr>
			<b-form v-if="!resetOk" ref="loginForm" @submit="onSubmit">
			<div class="row justify-content-md-center">
				<div class="col-sm-8">
					<b-form-group label="Email">
						<b-form-input
							v-model="form.email"
							type="text"
							required
						></b-form-input>
					</b-form-group>
				</div>
			</div>
				<p class="text-danger" v-if="error">An error occurred, please try again later</p>
				<br>
				<div class="text-center">
					<b-button variant="primary" type="submit" >Recover password</b-button>
					<br>
					<br>
					<a href="/login" @click="$root.setRouteEvt">Back</a>
				</div>
			</b-form>
			<div v-else>
				<p>An email has been sent to your email to recover your password, follow the instructions.</p>
				<a href="/login" @click="$root.setRouteEvt">LOGIN</a>
			</div>
		</b-modal>
	</section>
</template>

<script>
import logo from '../../../assets/logo-sc-negro.png'

export default {
  components: {  },
  data(){
	return {
		resetOk:false,
		logo,
		form : {
			email:'',
		},
		error:false,
		loading:false,
	}
  },
  methods:{
	resetPass(event){
		console.log(event)
	},
	onSubmit(evt){
		evt.preventDefault();
		this.error = false;
		this.loading = true;
		this.$root.api.post('/auth/reset-password',this.form).then(() => {
			this.resetOk = true
			this.loading = false;
		}).catch(()=>{
			this.loading = false;
			this.error = true;
		}).then(()=>{
		});
	},
  },
  mounted(){
	this.$refs['modalLogin'].show();
  }
}
</script>

<style>

</style>
